module.exports = {"350428100":"古镛镇","350428101":"万安镇","350428102":"高唐镇","350428103":"白莲镇","350428104":"黄潭镇","350428105":"水南镇","350428200":"光明乡","350428201":"漠源乡","350428202":"南口乡","350428203":"万全乡","350428204":"安仁乡","350428205":"大源乡","350428206":"余坊乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/350428.json
// module id = 1194
// module chunks = 0